
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M4.223 4h15.614a3 3 0 012.987 2.726A46.12 46.12 0 0123 10.923c0 1.782-.08 3.564-.241 5.346A3 3 0 0119.771 19H4.223a3 3 0 01-2.987-2.72A51.277 51.277 0 011 11.5c0-1.51.079-3.104.236-4.78A3 3 0 014.223 4z","opacity":".3"}}),_c('path',{attrs:{"d":"M11.182 14.805l4.404-3.01a.5.5 0 000-.824l-4.403-3.03a.5.5 0 00-.783.413v6.039a.5.5 0 00.782.412z"}})])])
          )
        }
      }
    